import React from 'react';
import { getImageName } from '../../utilities/String';

const Image = props => (
    <img
        alt={props.card.name}
        className="mx-auto w-full max-w-sm rounded-2xl shadow-xl ring-1 ring-base-300/50"
        src={require('../../img/cards/' + getImageName(props.card) + '.JPG')}
    />
);

export default Image;